// import node module libraries
import { Fragment } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Dropdown, ListGroup } from 'react-bootstrap';

// simple bar scrolling used for notification item scrolling
import 'simplebar/dist/simplebar.min.css';

// import custom components
import DarkLightMode from 'layouts/DarkLightMode';

// import media files
// import data files
import UtilisateurService from '../components/dashboard/services/UtilisateurService';
import { Avatar } from '../components/elements/bootstrap/Avatar';
import { useNavigate } from 'react-router-dom';

const QuickMenu = () => {
	const isDesktop = useMediaQuery({
		query: '(min-width: 1224px)'
	});

	const navigate = useNavigate();

	const getInitials = (name) => {
		const parts = name.split(' '); // splits by space
		const firstNameInitial = parts[0] ? parts[0].charAt(0).toUpperCase() : '';
		const lastNameInitial = parts[1] ? parts[1].charAt(0).toUpperCase() : '';
		return `${firstNameInitial}${lastNameInitial}`;
	};

	const userDetails = UtilisateurService.getUserDetailsFromLocalStorage();

	if (!userDetails || !userDetails.name) return null; // or display a loader if data is still loading

	const initials = getInitials(userDetails.name);

	const handleLogout = () => {
		UtilisateurService.logoutUser();
		navigate('/authentication/sign-in');
	};

	return (
		<Fragment>
			<DarkLightMode />
			<ListGroup
				as="ul"
				bsPrefix="navbar-nav"
				className="navbar-right-wrap ms-2 d-flex nav-top-wrap"
			>
				<Dropdown as="li" className="ms-1">
					<Dropdown.Toggle
						as="a"
						bsPrefix=" "
						className="rounded-circle"
						id="dropdownUser"
					>
						<div className="avatar avatar-md">
							<Avatar
								type="initial"
								size="md"
								name={initials}
								status="online"
								className="rounded-circle"
								alt={initials}
							/>
						</div>
					</Dropdown.Toggle>
					<Dropdown.Menu
						show={isDesktop}
						className="dashboard-dropdown dropdown-menu-end mt-4 py-0"
						aria-labelledby="dropdownUser"
						align="end"
					>
						<Dropdown.Item className="mt-3">
							<div className="d-flex">
								<div className="avatar avatar-md">
									<Avatar
										type="initial"
										size="md"
										name={initials}
										status="online"
										className="rounded-circle"
										alt={initials}
									/>
								</div>
								<div className="ms-3 lh-1">
									<h5 className="mb-1">{userDetails.name}</h5>
									<p className="mb-0 text-muted">{userDetails.username}</p>
								</div>
							</div>
						</Dropdown.Item>
						<Dropdown.Divider />
						<Dropdown.Item className="mb-3" onClick={handleLogout}>
							<i className="fa-solid fa-power-off me-2"></i> Se déconnecter
						</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</ListGroup>
		</Fragment>
	);
};

export default QuickMenu;
